import { Delay } from "components/atoms/Delay";
import { fortuneTellerIcon } from "components/templates/無料占いBot";
import { Balloon } from "features/無料占いBot/components/Balloon";
import { Confirmable } from "features/無料占いBot/components/Confirmable";
import { ChangeEventHandler, FocusEventHandler, useState } from "react";
import { useFormContext } from "react-hook-form";
import { eventName, eventAction, useGaEvent } from "shared/hooks/useGaEvent";

const fieldName = "name";

interface Props {
  htmlNative?: boolean;
}

export const InputName = ({ htmlNative }: Props) => {
  const [tmpValue, setTmpValue] = useState<string>();

  const { register, watch, setValue, trigger } = useFormContext();
  const { sendEvent } = useGaEvent();

  const [value, themeId, answerId] = watch([fieldName, "theme", "answer"]);
  const { onChange, onBlur } = register(fieldName);

  /**
   * NOTE: htmlNativeプロパティがtrueの時は入力の度にonChangeイベントを発火させず、onBlurのタイミングで値を反映させる
   * see: https://ja.reactjs.org/docs/dom-elements.html#onchange
   */
  const handleChangeInput: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (htmlNative) {
      setTmpValue(e.target.value);
    } else {
      onChange(e);
    }
  };

  const handleBlurInput: FocusEventHandler<HTMLInputElement> = (e) => {
    if (htmlNative) {
      setValue("name", tmpValue);
      trigger("name");
    } else {
      onBlur(e);
    }
  };

  const onClickConfirm = () => {
    sendEvent({
      eventName: eventName.freeFortuneChatBot,
      eventAction: eventAction.freeFortuneChatBot.confirmName,
      eventParams: {
        theme_id: themeId,
        answer_id: answerId,
      },
    });
  };

  return (
    <Confirmable
      name={fieldName}
      icon={fortuneTellerIcon}
      text={`お名前(またはニックネーム)は${value}でお間違いありませんか？`}
      onClickConfirm={onClickConfirm}
    >
      <Delay icon={fortuneTellerIcon}>
        <Balloon icon={fortuneTellerIcon}>
          {`ありがとうございます😌\nでは最後にあなたのお名前(またはニックネーム)を教えてください`}
        </Balloon>
        <div tw="justify-end flex">
          <input
            {...register(fieldName)}
            onChange={handleChangeInput}
            onBlur={handleBlurInput}
            placeholder="お名前を入力"
            tw="mt-4 border-card"
          />
        </div>
      </Delay>
    </Confirmable>
  );
};
